import makeStyles from '@mui/styles/makeStyles';
import Backdrop from "@mui/material/Backdrop";
import Grow from "@mui/material/Grow";
import Modal from "@mui/material/Modal";
import confettiBanner from 'common/assets/match_confetti.webp';
import CtaButton from "components/redesign/CtaButton";
import {Check} from "lucide-react";
import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {color, match, radius, shadow, type} from "common/tokens";

const AUTO_CLOSE_MS = 4000;

const useStyles = makeStyles({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
  },
  paper: {
    background: color.SURFACE,
    borderRadius: radius.PANEL,
    boxShadow: shadow.POPOVER,
    width: '100%',
    maxWidth: 620,
    outline: 'none',
    overflow: 'hidden',
    textAlign: 'center',
  },
  confetti: {
    width: '100%',
    height: 130,
    objectFit: 'cover',
    display: 'block',
  },
  content: {
    padding: '0 40px 32px',
  },
  tick: {
    width: 48,
    height: 48,
    borderRadius: '50%',
    background: match.ACCEPT_BG,
    color: match.ACCEPT_FG,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: -24,
  },
  title: {
    ...type.pageTitle,
    color: color.TEXT,
    marginTop: 16,
  },
  proceed: {
    width: 380,
    maxWidth: '100%',
  },
  description: {
    ...type.body,
    color: color.TEXT_MUTED,
    margin: '12px auto 24px',
    maxWidth: 460,
  },
});

const CongratulationsWindow = ({open, handleClose, formed = false}) => {
  const classes = useStyles();
  const {t} = useTranslation();

  useEffect(() => {
    if (!open) {
      return undefined;
    }
    const timer = setTimeout(handleClose, AUTO_CLOSE_MS);
    return () => clearTimeout(timer);
  }, [open, handleClose]);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      className={classes.modal}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{timeout: 220}}
    >
      <Grow in={open} timeout={{enter: 240, exit: 160}}>
        <div className={classes.paper}>
          <img src={confettiBanner} alt={''} className={classes.confetti}/>
          <div className={classes.content}>
            <span className={classes.tick}><Check size={24} strokeWidth={3}/></span>
            <div className={classes.title}>{t('congratulations')}</div>
            <div className={classes.description}>
              {t(formed ? 'mentorshipFormedDescription' : 'congratulationsDescription')}
            </div>
            <CtaButton label={t('proceed')} size={'large'} onClick={handleClose} className={classes.proceed}/>
          </div>
        </div>
      </Grow>
    </Modal>
  );
};

export default CongratulationsWindow;
